import * as types from '../../mutation_type'
import { setCookie } from '../../../../../../util/util'
export default {
  [types.QUERYCODEINFO] (state, res) {
    state.selProvinces = res.data.data
  },
  [types.GETSYSMARINFO](state, res) {
    state.sysmarinfo = res.data.data
},
  [types.GETADDRESSCITY] (state, res) {
    state.selCity = res.data.data
  },
  [types.GETADDRESSAREA] (state, res) {
    state.selArea = res.data.data
  },
  [types.GETPUBORDPRINTINFO](state, res) {
    setCookie('getPubordprintinfo', JSON.stringify(res.data.data));
  },
}



// WEBPACK FOOTER //
// ./src/pages/pc_mall_intact/store/modules/cardProject/mutations/mutation.js